import {DEFAULT_PER_PAGE} from "@constants/params";
import React from 'react'
import {IQueryParamsContext} from "@hooks/query/types/queryParams";

interface IProps<T> {
	initialOrder?: keyof T | false,
	initialDirection?: 'ASC' | 'DESC',
	initialPage?: number
	initialPerPage?: number,
	initialSearchValue?: string,
	initialSearchKey?: keyof T | 'ALL_SEARCH_FIELDS' | false,
}

export function useQueryParams<T = unknown>({
												initialOrder,
												initialDirection,
												initialPage = 1,
												initialPerPage = DEFAULT_PER_PAGE,
												initialSearchValue = '',
												initialSearchKey = false,
											}: IProps<T> = {
	initialPage: 1,
	initialPerPage: DEFAULT_PER_PAGE,
	initialSearchValue: '',
}): IQueryParamsContext<T> {
	
	const [order, setOrder] = React.useState<keyof T | false>(initialOrder);
	const [direction, setDirection] = React.useState<'ASC' | 'DESC'>(initialDirection);
	
	
	const [page, setPage] = React.useState<number>(initialPage);
	const [perPage, setPerPage] = React.useState<number>(initialPerPage);
	
	const [searchValue, setSearchValue] = React.useState<string>(initialSearchValue);
	const [searchKey, setSearchKey] = React.useState<keyof T | 'ALL_SEARCH_FIELDS' | false>(initialSearchKey);
	
	
	return {
		order, setOrder,
		direction, setDirection,
		page, setPage,
		perPage, setPerPage,
		searchValue, setSearchValue,
		searchKey, setSearchKey,
		initialPage,
	}
	
	
}